import React from 'react';
import { Tooltip } from '../../../../../../tooltip/tooltip';
import { IconHelpFilled } from '../../../../../../icons/help-filled';
import Skeleton from '../../../../../skeleton';
import { SkeletonDashboardCardsDividendsDivider } from '../divider/skeleton-dashboard-cards-dividends-divider';
import { SkeletonDashboardCardsDividendsRow } from '../row/skeleton-dashboard-cards-dividends-row';
import { SkeletonDashboardCardsDividendsSection } from '../section/skeleton-dashboard-cards-dividends-section';

interface SkeletonDashboardCardsDividendsContentProps {
    yieldLabel: string;
    yieldOnCostLabel: string;
    predictionLabel: string;
    payoutLabel: string;
}

export const SkeletonDashboardCardsDividendsContent: React.FC<SkeletonDashboardCardsDividendsContentProps> = ({
    yieldLabel,
    yieldOnCostLabel,
    predictionLabel,
    payoutLabel,
}) => (
    <div className="flex flex-col md:flex-row md:items-center md:gap-small">
        <SkeletonDashboardCardsDividendsSection>
            <SkeletonDashboardCardsDividendsRow>
                <div className="font-black">
                    <Skeleton />
                </div>
                {yieldLabel}
            </SkeletonDashboardCardsDividendsRow>
            <SkeletonDashboardCardsDividendsRow>
                <div className="font-black">
                    <Skeleton />
                </div>
                {yieldOnCostLabel}
            </SkeletonDashboardCardsDividendsRow>
        </SkeletonDashboardCardsDividendsSection>

        <SkeletonDashboardCardsDividendsDivider />

        <SkeletonDashboardCardsDividendsSection>
            <SkeletonDashboardCardsDividendsRow>
                {predictionLabel}
                <Tooltip content={predictionLabel}>
                    <IconHelpFilled />
                </Tooltip>
            </SkeletonDashboardCardsDividendsRow>
            <SkeletonDashboardCardsDividendsRow strong>
                <Skeleton />
            </SkeletonDashboardCardsDividendsRow>
        </SkeletonDashboardCardsDividendsSection>

        <SkeletonDashboardCardsDividendsDivider />

        <SkeletonDashboardCardsDividendsSection>
            <SkeletonDashboardCardsDividendsRow>{payoutLabel}</SkeletonDashboardCardsDividendsRow>
            <SkeletonDashboardCardsDividendsRow large>
                <Skeleton />
            </SkeletonDashboardCardsDividendsRow>
        </SkeletonDashboardCardsDividendsSection>
    </div>
);
